// SP では .giraffe-collection-toolbar__facets を .giraffe-collection-count の右に表示するため、
// ビューポートに応じてDOMを移動する。PC に戻ったら元の toolbar 内に戻す。
(() => {
  const mql = window.matchMedia('(max-width: 749px)');

  const place = () => {
    const facets = document.querySelector('.giraffe-collection-toolbar__facets');
    const count = document.querySelector('.giraffe-collection-count');
    if (!facets || !count) return;
    const toolbar = document.querySelector('.giraffe-collection-toolbar');

    if (mql.matches) {
      let wrap = document.querySelector('.giraffe-collection-count-row');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'giraffe-collection-count-row';
        count.parentNode.insertBefore(wrap, count);
        wrap.appendChild(count);
      }
      if (facets.parentNode !== wrap) wrap.appendChild(facets);
    } else {
      if (toolbar && facets.parentNode !== toolbar) toolbar.appendChild(facets);
      const wrap = document.querySelector('.giraffe-collection-count-row');
      if (wrap) {
        if (count.parentNode === wrap) wrap.parentNode.insertBefore(count, wrap);
        if (!wrap.children.length) wrap.remove();
      }
    }
  };

  const ready = (fn) => {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  ready(place);
  if (mql.addEventListener) mql.addEventListener('change', place);
  else if (mql.addListener) mql.addListener(place);

  // 商品一覧のタブ切り替え後も反映されるよう、関連要素の差し替えを監視
  ready(() => {
    const targets = [
      document.getElementById('ProductGridContainer'),
      document.getElementById('main-collection-filters'),
    ].filter(Boolean);
    if (!targets.length) return;
    const observer = new MutationObserver(() => place());
    targets.forEach((el) => observer.observe(el, { childList: true, subtree: true }));
  });
})();
